import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {BiolinkEditorService} from '../../biolink-editor.service';
import {map, startWith} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {BiolinkBtnConfig} from '../../../biolink';
import {FormControl} from '@angular/forms';

@Component({
    selector: 'biolink-editor-buttons',
    templateUrl: './biolink-editor-buttons.component.html',
    styleUrls: ['./biolink-editor-buttons.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BiolinkEditorButtonsComponent implements OnInit {
    colorControl = new FormControl();
    active$: Observable<BiolinkBtnConfig> = this.editor.appearanceForm
        .get('btnConfig')
        .valueChanges.pipe(
            startWith({}),
            map(c => c ?? {})
        );

    constructor(private editor: BiolinkEditorService) {}

    ngOnInit() {
        this.colorControl.valueChanges.subscribe(color => {
            this.editor.appearanceForm.get('btnConfig.color').setValue(color);
            this.editor.appearanceForm.markAsDirty();
        });
    }

    changeBtnType(
        type: BiolinkBtnConfig['type'],
        variant: BiolinkBtnConfig['variant']
    ) {
        this.editor.appearanceForm.patchValue({
            btnConfig: {
                type,
                variant,
            },
        });
        this.editor.appearanceForm.markAsDirty();
    }
}
